export class SendPriceMatchCompetitorInformation {
    company?: string;
    website?: string;
}